/* global gec:true */
/* eslint-disable prefer-template */
/* exported gec */
gec = (function (gec) {
    "use strict";

    const gecPrivate = gec.gecPrivate || {};
    const gecSeal = gec.gecSeal || function () {
        delete gec.gecPrivate;
        delete gec.gecSeal;
        delete gec.gecUnseal;
    };
    const gecUnseal = gec.gecUnseal || function () {
        gec.gecPrivate = gecPrivate;
        gec.gecSeal = gecSeal;
        gec.gecUnseal = gecUnseal;
    };

    /** **************************
    getMultiplesSBBaseCombinations
    ****************************/
    gec.Controller.prototype.getMultiplesSBBaseCombinations = function (params) {
        var dg = ["Zero", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen", "Twenty"];
        var type = {};
        var subType = {};
        const combinations = params.combinations || [];
        const totalCombinationCount = params.totalCombinationCount;
        const finalCombinations = [];
        const goliath = {
            "name": "Goliath ({0})",
            "hasAccaGroupName": true,
            "count": 247,
            "legs": [2, 3, 4, 5, 6, 7, 8]
        };
        const superHeinz = {
            "name": "Super Heinz ({0})",
            "hasAccaGroupName": true,
            "count": 120,
            "level": 0,
            "legs": [2, 3, 4, 5, 6, 7]
        };
        const heinz = {
            "name": "Heinz ({0})",
            "hasAccaGroupName": true,
            "count": 57,
            "level": 0,
            "legs": [2, 3, 4, 5, 6]
        };
        const lucky63 = {
            "name": "Lucky 63 ({0})",
            "hasAccaGroupName": true,
            "count": 63,
            "level": 0,
            "legs": [1, 2, 3, 4, 5, 6]
        };
        const superYankee = {
            "name": "Super Yankee ({0})",
            "hasAccaGroupName": true,
            "count": 26,
            "level": 0,
            "legs": [2, 3, 4, 5]
        };
        const lucky31 = {
            "name": "Lucky 31 ({0})",
            "hasAccaGroupName": true,
            "count": 31,
            "level": 0,
            "legs": [1, 2, 3, 4, 5]
        };
        const yankee = {
            "name": "Yankee ({0})",
            "hasAccaGroupName": true,
            "count": 11,
            "level": 0,
            "legs": [2, 3, 4]
        };
        const lucky15 = {
            "name": "Lucky 15 ({0})",
            "hasAccaGroupName": true,
            "count": 15,
            "level": 0,
            "legs": [1, 2, 3, 4]
        };
        const trixie = {
            "name": "Trixie ({0})",
            "hasAccaGroupName": true,
            "count": 4,
            "level": 0,
            "legs": [2, 3]
        };
        const patent = {
            "name": "Patent ({0})",
            "hasAccaGroupName": true,
            "count": 7,
            "level": 0,
            "legs": [1, 2, 3]
        };

        combinations.forEach(function (combination) {
            const combinationToPush = {};
            const betString = combination.combinationCount > 1 ? "Bets" : "Bet";
            if (combination.combinationType === 1) {
                combinationToPush.name = String.format("Singles ({0} {1})", combination.combinationCount, betString);
                combinationToPush["0name"] = String.format("({0} {1}) Singles", combination.combinationCount, betString);
            } else if (combination.combinationType === 2) {
                combinationToPush.name = String.format("Double ({0} {1})", combination.combinationCount, betString);
                combinationToPush["0name"] = String.format("({0} {1}) Double", combination.combinationCount, betString);
            } else if (combination.combinationType === 3) {
                combinationToPush.name = String.format("Treble ({0} {1})", combination.combinationCount, betString);
                combinationToPush["0name"] = String.format("({0} Bets) Treble", combination.combinationCount, betString);
            } else {
                const combinationName = dg[combination.combinationType] + " Folds";
                combinationToPush.name = String.format(combinationName + " ({ 0} Bets)", combination.combinationCount, betString);
                combinationToPush["0name"] = String.format("({0} {1}) " + combinationName, combination.combinationCount, betString);
            }
            combinationToPush.count = combination.combinationCount;
            combinationToPush.legs = [combination.combinationType];
            combinationToPush.hasAccaGroupName = false;
            finalCombinations.push(combinationToPush);
        });

        const indexToMove = finalCombinations.indexOf(finalCombinations[finalCombinations.length - 1]);
        if (finalCombinations.length >= 2 && indexToMove !== -1) {
            finalCombinations.unshift(finalCombinations.splice(indexToMove, 1)[0]);
        }

        if (finalCombinations.length === superHeinz.legs.length && totalCombinationCount % superHeinz.count === 0) {
            superHeinz.count = totalCombinationCount;
            finalCombinations.push(superHeinz);
        }
        if (finalCombinations.length === goliath.legs.length && totalCombinationCount % goliath.count === 0) {
            goliath.count = totalCombinationCount;
            finalCombinations.push(goliath);
        } else if (finalCombinations.length === 6) {
            type = heinz;
            subType = lucky63;
        } else if (finalCombinations.length === 5) {
            type = superYankee;
            subType = lucky31;
        } else if (finalCombinations.length === 4) {
            type = yankee;
            subType = lucky15;
        } else if (finalCombinations.length === 3) {
            type = trixie;
            subType = patent;
        }

        if (Object.keys(type).length !== 0 && Object.keys(subType).length !== 0) {
            let typeCount = 0;
            type.legs.forEach(function (leg) {
                typeCount = typeCount + combinations.find(function (c) {
                    return c.combinationType === leg;
                }).combinationCount;
            });
            if (typeCount % type.count === 0) {
                finalCombinations.push(type);
                type.count = typeCount;
            }
            if (totalCombinationCount % subType.count === 0) {
                subType.count = totalCombinationCount;
                finalCombinations.push(subType);
            }
        }
        return finalCombinations;
    };

    /** **************************
    listMultipleBets
    ****************************/
    gec.Controller.prototype.listMultipleBets = function (params) {
        if (gecPrivate.userContext === null) {
            params.callbackOnException({ "returnCode": 590, "message": "NeitherUserNorTelebetUserSession " });
        } else {
            const request = new gec.IAPIRequest(params);
            request.sessionToken = gecPrivate.sessionToken;
            this.sendRequest("/ListMultipleBets.ashx", request, function listMultipleBetsResponse(requestParam, response) {
                if (response.returnCode !== 0) {
                    request.callbackOnException({ "returnCode": response.returnCode });
                } else {
                    const betArray = [];
                    if (response.multipleBets !== undefined) {
                        response.multipleBets.forEach(function (item) {
                            const betObject = new gec.MultipleBet(item);
                            betObject.multipleBetId = item.multipleBetId;
                            betObject.accaGroupId = item.accaGroupId;
                            betObject.accaGroupName = item.accaGroupName;
                            betObject.clientGroupReference = item.clientGroupReference;
                            betObject.cashOutHistories = item.cashOutHistories;

                            betObject.selections = [];
                            item.multipleLegs.forEach(function (gbeselection) {

                                betObject.selections.push({
                                    selectionName: gbeselection.selectionName,
                                    marketName: gbeselection.marketName,
                                    eventClassifierFullName: gbeselection.eventClassifierFullName,
                                    startTime: gbeselection.startTime,
                                    multipleLegStatusId: gbeselection.multipleLegStatus
                                });
                            });

                            betObject.requestedStake = item.requestedStake.amount;
                            betObject.totalMatchedStake = item.totalMatchedStake.amount;
                            betObject.requestedPrice = item.requestedPrice;
                            betObject.averageMatchedPrice = item.averageMatchedPrice;
                            betObject.rolloverStake = item.rolloverStake.amount;
                            betObject.numberOfUnsettledSelections = item.numberOfUnsettledSelections;
                            betObject.unsettledPrice = item.unsettledPrice;
                            betObject.totalMaxUpside = item.totalMaxUpside;
                            betObject.multipleBetStatusId = 1;
                            betObject.placedAt = item.placedAt;
                            betObject.commissionRate = item.commissionRate;
                            betObject.isFreeBet = item.isFreeBet;

                            betObject.iPAddress = item.iPaddress;
                            betObject.iPCountryCode = item.iPCountryCode;
                            betObject.channelInformation = item.channelInformation;

                            if (item.cashOutHistories !== undefined) {
                                betObject.cashOutHistories = item.cashOutHistories;
                            }

                            betArray.push(betObject);
                        });

                        betArray.sort(gec.SortOnMultiplebetId);
                        betArray.reverse();
                    }
                    request.callbackOnSuccess(betArray);
                }

            });
        }
    };

    /** **************************
    getMultipleBetDetails
    ****************************/
    gec.Controller.prototype.getMultipleBetDetails = function (params) {
        const request = new gec.IAPIRequest(params);
        request.sessionToken = gecPrivate.sessionToken;
        request.multipleBetId = params.multipleBetId;

        this.sendRequest("/GetMultipleBetDetails.ashx", request, function (requestParam, response) {

            if (response.returnCode !== 0) {

                request.callbackOnException({ "returnCode": response.returnCode });
            } else {
                const betObject = new gec.MultipleBetDetail(response);

                betObject.multipleBetId = response.multipleBetId;
                betObject.requestedStake = response.requestedStake.amount;
                betObject.totalMatchedStake = response.totalMatchedStake.amount;
                betObject.requestedPrice = response.requestedPrice;
                betObject.averageMatchedPrice = response.averageMatchedPrice;
                betObject.effectivePrice = response.effectivePrice;
                betObject.rolloverStake = response.rolloverStake.amount;
                betObject.numberOfUnsettledSelections = response.numberOfUnsettledSelections;
                betObject.unsettledPrice = response.unsettledPrice;
                betObject.totalMaxUpside = response.totalMaxUpside.amount;
                betObject.multipleBetStatusId = response.status;
                betObject.placedAt = response.placedAt;
                betObject.commissionRate = response.commissionRate;
                betObject.isFreeBet = response.isFreeBet;
                if (response.cashOutHistories !== undefined) {
                    betObject.cashOutHistories = response.cashOutHistories;
                }
                betObject.settledAt = response.settledAt;
                betObject.settlementAmount = response.settlementAmount;
                betObject.iPAddress = response.iPAddress;
                betObject.ipCountryCode = response.iPCountryCode;

                betObject.channelInformation = response.channelInformation;

                response.multipleLegs.forEach(function (item) {
                    item.multipleLegStatusId = item.multipleLegStatus;
                    delete item.multipleLegStatus;
                });

                betObject.selections = response.multipleLegs;

                betObject.matches = [];
                if (response.partialMatches !== undefined) {

                    response.partialMatches.forEach(function (partialMatch) {
                        const match = {
                            matchedStake: partialMatch.matchedStake.amount,
                            rolloverStake: partialMatch.rolloverStake.amount,
                            maxUpside: partialMatch.maxUpside.amount,
                            indicativePrice: partialMatch.indicativePrice,
                            effectivePrice: partialMatch.effectivePrice,
                            unsettledPrice: partialMatch.unsettledPrice,
                            selectionPrices: []
                        };

                        partialMatch.selectionPrices.forEach(function (selectionPrice) {
                            const selitem = {
                                priceWhenPlaced: selectionPrice.priceWhenPlaced,
                                priceWhenSettled: selectionPrice.priceWhenSettled,
                                selectionId: selectionPrice.selectionId,
                                selections: []
                            };

                            response.multipleLegs.forEach(function (multipleLeg) {

                                const matchedsel = {
                                    selectionId: multipleLeg.selectionId,
                                    selectionName: multipleLeg.selectionName,
                                    marketName: multipleLeg.marketName,
                                    eventClassifierFullName: multipleLeg.eventClassifierFullName,
                                    startTime: multipleLeg.startTime,
                                    multipleLegStatusId: multipleLeg.multipleLegStatus,
                                    voidPercentage: multipleLeg.voidPercentage,
                                    leftSideFactor: multipleLeg.leftSideFactor,
                                    rightSideFactor: multipleLeg.rightSideFactor
                                };

                                selitem.selections.push(matchedsel);

                            });
                            match.selectionPrices.push(selitem);
                        });

                        betObject.matches.push(match);
                    });
                }


                request.callbackOnSuccess(betObject);
            }


        });
    };


    /** **************************
    requestMultipleBetQuotation
    ****************************/
    gec.Controller.prototype.requestMultipleBetQuotation = function (params) {

        if (gecPrivate.controllerDefaults === null && gecPrivate.userContext === null) {
            params.callbackOnException({ "returnCode": 591 });
        } else {
            const request = new gec.IAPIRequest(params);
            let currencyCode;
            if (gecPrivate.userContext !== null) {
                request.sessionToken = gecPrivate.sessionToken;
                currencyCode = gecPrivate.userContext.currency;
            } else {
                request.integrationPartnerId = gecPrivate.controllerDefaults.integrationPartnerId;
                request.currency = gecPrivate.controllerDefaults.currency;
                request.language = gecPrivate.controllerDefaults.language;
                currencyCode = gecPrivate.controllerDefaults.currency;
            }

            request.selectionIds = [];
            params.indexedSelections = [];
            params.selections.forEach(function (gbeselection) {
                request.selectionIds.push(gbeselection.selectionId);
                params.indexedSelections[gbeselection.selectionId] = gbeselection;
            });
            request.minOffer = { "amount": params.minOffer, "currency": currencyCode };
            request.combinations = params.levels;

            // backward compatible code
            request.selectionIds = params.selectionIds || request.selectionIds;
            request.combinations = params.numberOfSelections || params.levels;

            this.sendRequest("/RequestMultipleBetQuotation.ashx", request, function (requestParam, response) {
                if (response.returnCode !== 0) {
                    request.callbackOnException({ "returnCode": response.returnCode });
                } else {
                    const offers = [];

                    response.betQuotations.forEach(function (betQuotation) {
                        const offer = {};
                        if (betQuotation.prices !== undefined) {

                            offer.offers = betQuotation.prices || [];
                            offer.selections = [];

                            betQuotation.selections.forEach(function (gbeselection) {
                                offer.selections.push(params.indexedSelections[gbeselection.selectionId]);
                            });
                        }
                        offers.push(offer);
                    });
                    request.callbackOnSuccess(offers);
                }
            });
        }
    };

    /** **************************
    placeMultipleBets
    ****************************/
    gec.Controller.prototype.placeMultipleBets = function (params) {

        if (gecPrivate.controllerDefaults === undefined && gecPrivate.userContext === null) {
            params.callbackOnException({ "returnCode": 591 });
        } else {
            const request = new gec.IAPIRequest(params);
            if (gecPrivate.userContext !== null) {
                request.sessionToken = gecPrivate.sessionToken;
                request.channelInformation = params.channelInformation || "GBEIntegrationSolution";
                request.wantAllOrNothing = params.wantAllOrNothing;
                request.useFreeBet = params.useFreeBet;

                request.requestedLegs = [];

                params.requestedBets.forEach(function (requestedBet) {

                    const requestedLeg = { "selections": [] };
                    requestedBet.selections.forEach(function (betselection) {

                        requestedLeg.selections.push({
                            selectionId: betselection.selectionId,
                            expectedSelectionResetCount: betselection.selectionResetCount,
                            expectedWithdrawalSequenceNumber: betselection.market.withdrawalSequenceNumber
                        });
                    });

                    requestedLeg.requestedGrossForSideStake = {};
                    if (requestedBet.clientGroupReference) {
                        requestedLeg.clientGroupReference = requestedBet.clientGroupReference;
                    }
                    if (requestedBet.accaGroupName) {
                        requestedLeg.accaGroupName = requestedBet.accaGroupName;
                    }
                    requestedLeg.requestedGrossForSideStake.amount = requestedBet.requestedGrossForSideStake;
                    requestedLeg.requestedGrossForSideStake.currency = gecPrivate.userContext.currency;
                    requestedLeg.requestedForSidePrice = requestedBet.requestedForSidePrice;


                    request.requestedLegs.push(requestedLeg);
                });
            }

            this.sendRequest("/PlaceMultipleBets.ashx", request, function (requestParam, response) {
                if (response.returnCode !== 0) {
                    request.callbackOnException({ "returnCode": response.returnCode });
                } else {
                    const returnObject = [];
                    gecPrivate.checkExpiredSession(response.returnCode);

                    response.multipleBetResults.forEach(function (multipleBetResult) {
                        const thisResult = {};

                        thisResult.returnCode = multipleBetResult.returnCode;
                        thisResult.multipleBetId = multipleBetResult.multipleBetId;
                        thisResult.matchedAmount = multipleBetResult.matchedAmount.amount;
                        thisResult.matchedPrice = multipleBetResult.matchedPrice;
                        if (multipleBetResult.accaGroupId) {
                            thisResult.accaGroupId = multipleBetResult.accaGroupId;
                        }
                        if (multipleBetResult.clientGroupReference) {
                            thisResult.clientGroupReference = multipleBetResult.clientGroupReference;
                        }
                        if (multipleBetResult.accaGroupName) {
                            thisResult.accaGroupName = multipleBetResult.accaGroupName;
                        }
                        returnObject.push(thisResult);
                    });
                    request.callbackOnSuccess(returnObject);
                }
            });
        }
    };


    /** **************************
    cashoutMultipleBets
    ****************************/

    gec.Controller.prototype.cashoutMultipleBets = function (params) {
        if (gecPrivate.userContext === null) {
            params.callbackOnException({ "returnCode": 590, message: "NeitherUserNorTelebetUserSession" });
        } else {
            const request = new gec.IAPIRequest(params);
            request.sessionToken = gecPrivate.sessionToken;
            request.wantAllOrNothing = params.wantAllOrNothing;
            request.firstRequestedAt = params.firstRequestedAt;
            request.betCashOutRequests = params.multipleBets;
            this.sendRequest("/CashoutMultipleBets.ashx", request, function (requestParam, response) {
                if (response.returnCode !== 0) {
                    request.callbackOnException({ "returnCode": response.returnCode });
                } else {
                    request.callbackOnSuccess(response);
                }
            });
        }
    };

    /** *******************************
    requestMultipleBetCashOutOffer
    *********************************/

    gec.Controller.prototype.requestMultipleBetCashOutOffer = function (params) {

        if (gecPrivate.userContext === null) {
            params.callbackOnException({ "returnCode": 590, "message": "NeitherUserNorTelebetUserSession" });
        } else {
            const request = new gec.IAPIRequest(params);
            request.sessionToken = gecPrivate.sessionToken;
            if (params.multipleBetId) {
                request.multipleBetId = params.multipleBetId;
            }
            if (params.accaGroupId) {
                request.accaGroupId = params.accaGroupId;
            }
            this.sendRequest("/RequestMultipleBetCashOutOffer.ashx", request, function (requestParam, response) {
                const returnObject = {};
                if (response.returnCode !== 0) {
                    params.callbackOnException({ "returnCode": response.returnCode });
                } else {
                    if (response.multipleBetCashOutOffers) {
                        returnObject.multipleBetCashOutOffers = response.multipleBetCashOutOffers;
                    }
                    if (response.totalCashOutOffer) {
                        returnObject.totalCashOutOffer = response.totalCashOutOffer;
                    }
                    if (response.totalEquityAmount) {
                        returnObject.totalEquityAmount = response.totalEquityAmount;
                    }
                    params.callbackOnSuccess(returnObject);
                }
            });
        }
    };

    /*
     * **************************
    listActiveMultipleBets
    ***************************
    */

    gec.Controller.prototype.listActiveMultipleBets = function (params) {

        if (gecPrivate.userContext === null) {
            params.callbackOnException({ "returnCode": 590, "message": "NeitherUserNorTelebetUserSession" });
        } else {
            const request = new gec.IAPIRequest(params);
            request.sessionToken = gecPrivate.sessionToken;
            request.embedAccaGroupItems = params.embedAccaGroupItems;

            this.sendRequest("/ListActiveMultipleBets.ashx", request, function listActiveMultipleBetsResponse(requestParams, response) {

                if (response.returnCode !== 0) {
                    params.callbackOnException({ "returnCode": response.returnCode });
                } else {
                    params.callbackOnSuccess({ "multipleBets": response.multipleBets });
                }
            });
        }
    };

    /*
    ***************************
    getSBMultipleBetDetails
    ***************************
    */

    gec.Controller.prototype.getSBMultipleBetDetails = function (params) {

        if (gecPrivate.userContext === null) {
            params.callbackOnException({ "returnCode": 590, "message": "NeitherUserNorTelebetUserSession" });
        } else {
            const request = new gec.IAPIRequest(params);
            request.sessionToken = gecPrivate.sessionToken;
            request.accessToken = params.accessToken;
            request.multipleBetId = params.multipleBetId;

            this.sendRequest("/GetSBMultipleBetDetails.ashx", request, function getSBMultipleBetsResponse(requestParams, response) {

                if (response.returnCode !== 0) {
                    params.callbackOnException({ "returnCode": response.returnCode });
                } else {
                    delete response.returnCode;
                    params.callbackOnSuccess(response);
                }
            });
        }
    };

    /*
    ***************************
    ListActiveSBMultipleBets
    ***************************
    */

    gec.Controller.prototype.listActiveSBMultipleBets = function (params) {

        if (gecPrivate.userContext === null) {
            params.callbackOnException({ "returnCode": 590, "message": "NeitherUserNorTelebetUserSession" });
        } else {
            const request = new gec.IAPIRequest(params);
            request.sessionToken = gecPrivate.sessionToken;
            request.accessToken = params.accessToken;
            request.multipleBetId = params.multipleBetId;
            request.includeCashOutHistory = params.includeCashOutHistory;
            request.status = params.status;

            this.sendRequest("/ListActiveSBMultipleBets.ashx", request, function listActiveMultipleBetsResponse(requestParams, response) {

                if (response.returnCode !== 0) {
                    params.callbackOnException({ "returnCode": response.returnCode });
                } else {
                    delete response.returnCode;
                    params.callbackOnSuccess(response);
                }
            });
        }
    };

    /*
    ***************************
    ListSBMultipleBets
    ***************************
    */

    gec.Controller.prototype.listSBMultipleBets = function (params) {

        if (gecPrivate.userContext === null) {
            params.callbackOnException({ "returnCode": 590, "message": "NeitherUserNorTelebetUserSession" });
        } else {
            const request = new gec.IAPIRequest(params);
            request.sessionToken = gecPrivate.sessionToken;
            request.accessToken = params.accessToken;
            request.multipleBetStatusId = params.multipleBetStatusId;
            request.includeCashOutHistory = params.includeCashOutHistory;
            request.placedAfter = params.placedAfter;
            request.placedBefore = params.placedBefore;
            request.eventClassifierId = params.eventClassifierId;
            request.marketId = params.marketId;
            request.selectionId = params.selectionId;
            request.startOffset = params.startOffset;
            request.numberToReturn = params.numberToReturn;

            this.sendRequest("/ListSBMultipleBets.ashx", request, function listSBMultipleBetsResponse(requestParams, response) {

                if (response.returnCode !== 0) {
                    params.callbackOnException({ "returnCode": response.returnCode });
                } else {
                    delete response.returnCode;
                    params.callbackOnSuccess(response);
                }
            });
        }
    };

    gec.SortOnMultiplebetId = function (a, b) {
        return b.multipleBetId > a.multipleBetId ? -1 : 1;
    };

    gec.MultipleBet = function (params) {
        this.multipleBetId = params.multipleBetId;
        this.selections = params.selections || [];
        this.requestedStake = params.requestedStake;
        this.totalMatchedStake = params.totalMatchedStake;
        this.requestedPrice = params.requestedPrice;
        this.averageMatchedPrice = params.averageMatchedPrice;
        this.rolloverStake = params.rolloverStake;
        this.numberOfUnsettledSelections = params.numberOfUnsettledSelections;
        this.unsettledPrice = params.unsettledPrice;
        this.totalMaxUpside = params.totalMaxUpside;
        this.multipleBetStatusId = params.multipleBetStatusId;
        this.placedAt = params.placedAt;
        this.commissionRate = params.commissionRate;
        this.isFreeBet = params.isFreeBet;
        this.totalCashOutAmount = params.totalCashOutAmount;
        this.totalCashOutStake = params.totalCashOutStake;
        this.iPAddress = params.iPAddress;
        this.ipCountryCode = params.ipCountryCode;
        this.channelInformation = params.channelInformation;

    };
    gec.MultipleBetDetail = function (params) {
        this.multipleBetId = params.multipleBetId;
        this.requestedStake = params.requestedStake;
        this.totalMatchedStake = params.totalMatchedStake;
        this.requestedPrice = params.requestedPrice;
        this.averageMatchedPrice = params.averageMatchedPrice;
        this.effectivePrice = params.effectivePrice;
        this.rolloverStake = params.rolloverStake;
        this.numberOfUnsettledSelections = params.numberOfUnsettledSelections;
        this.unsettledPrice = params.unsettledPrice;
        this.totalMaxUpside = params.totalMaxUpside;
        this.multipleBetStatusId = params.multipleBetStatusId;
        this.placedAt = params.placedAt;
        this.commissionRate = params.commissionRate;
        this.isFreeBet = params.isFreeBet;
        this.totalCashOutAmount = params.totalCashOutAmount;
        this.totalCashOutStake = params.totalCashOutStake;

        this.settledAt = params.settledAt;
        this.settlementAmount = params.settlementAmount;
        this.matches = params.matches || [];
        this.iPAddress = params.iPAddress;
        this.ipCountryCode = params.ipCountryCode;
        this.channelInformation = params.channelInformation;

    };
    gec.MultipleLegStatus = Object.freeze({
        "Unkown": 1, "Won": 2, "Lost": 3, "Voided": 4
    });

    return gec;

}(gec || {}));